// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"f6a24da6","130":"c810d0eb","229":"c09092e5","230":"1ca1ab2a","231":"456cb456","453":"4f112b71"}[chunkId] + ".chunk.js";
};